
// Data queried successfully
export interface GetResponse {
  "data": {
    "lastRow": number,
    "rows": any[],
  },
  "statusCode": 200 | 'Ok',
  "message": string
}


// Bad request or invalid payload format
export interface Get400 {
  "statusCode": 400 | string,
  "message": string
}

// Internal server error while processing the request
export interface Get500 {
  "isError": true,
  "validationErrors": [
    {
      "name": string,
      "reason": string
    }
  ],
  "type": string,
  "title": string,
  "status": number | string,
  "detail": string,
  "instance": string,
  "additionalProp1": string,
  "additionalProp2": string,
  "additionalProp3": string
}

// Respuesta cuando hay un error no definido
export interface GetError {
  "type": string,
  "title": string,
  "status": number | string,
  "detail": string,
  "instance": string,
  "additionalProp1": string,
  "additionalProp2": string,
  "additionalProp3": string
}

